<template>
  <g>
    <g
      v-for="(o, i) in labels"
      :key="i"
      :style="`transform: translate(${o.pos.cx}px, ${o.pos.cy}px);`"
    >
      <text
        v-if="showLabelOverlay"
        :x="circleRadius * 1.5"
        :y="circleRadius"
        :style="`font: bold ${labelScale * 10}px sans; pointer-events: none;`"
      >
        {{ o.name }}
      </text>
      <circle
        :r="circleRadius"
        class="label"
        :style="labelToStyle(o)"
        @mousedown="onClickLabel($event, i)"
      >
        <title>{{ o.name }}</title>
      </circle>
    </g>
  </g>
</template>

<script>
import useLabels from "@/composables/useLabels";
import useBasicStyles from "@/composables/useBasicStyles";
import ui from "@/store/modules/ui";
import { computed } from "@vue/composition-api";

export default {
  props: {
    shouldBlock: Boolean
  },
  setup(props) {
    //
    // Props
    // -------------------------------------------------------------------
    //
    const { shouldBlock } = props;
    //
    // Composables
    // ---------------------------------------------------------------
    //
    const { labels, move: moveLabel, remove: removeLabel } = useLabels();
    const { circleStyles } = useBasicStyles();
    //
    // Events: Click on label
    // -------------------------------------------------------------------
    //
    function onClickLabel(e, i) {
      if (shouldBlock.value) return;
      notifyChange();

      switch (ui.annoType) {
        case "remove":
          removeLabel(e, i);
          break;
        case "move":
          moveLabel(e, i);
          break;
      }
    }
    function notifyChange() {
      if (!ui.hasUnsavedChange) {
        ui.setHasUnsavedChange(true);
      }
    }
    //
    // Styles
    // -------------------------------------------------------------------
    //
    function labelToStyle(labelObject) {
      const style = {};
      const labelConfig = ui.labelTypes.find(o => o.name == labelObject.name);
      if (labelConfig == undefined) {
        style.fill = "#000";
      } else {
        style.fill = labelConfig.bgColor;
      }
      return {
        ...circleStyles.value,
        ...style
      };
    }

    return {
      labels,
      labelToStyle,
      circleRadius: computed(() => ui.circleRadius),
      showLabelOverlay: computed(() => ui.showLabelOverlay),
      labelScale: computed(() => ui.labelScale),
      onClickLabel
    };
  }
};
</script>

<style lang="scss" scoped>
.label {
  stroke: #000;
  stroke-width: 1px;
}
.label:hover {
  stroke: greenyellow;
  stroke-width: var(--stroke-width-hover);
}
</style>
